import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from "@recore-solutions/nstar-lib";
import { ConfigurationService } from "src/app/configuration.service";
import { PermissionListGuard } from "src/app/permission-list.guard";
import { PreferencesService } from "src/app/preferences/preferences.service";
import { ListingResultComponent } from "../listing-result/listing-result.component";

@Component({
	selector: "app-listing-row",
	templateUrl: "./listing-row.component.html",
	styleUrls: ["./listing-row.component.scss"],
	providers: [NgbDropdown],
})
export class ListingRowComponent extends ListingResultComponent implements OnInit {
	constructor(
		protected router: Router,
		protected configurationService: ConfigurationService,
		protected preferenceService: PreferencesService,
		protected sessionService: SessionService,
		protected permissionListGuard: PermissionListGuard
	) {
		super(router, configurationService, preferenceService, sessionService, permissionListGuard);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
}
